export default __webpack_public_path__ + "static/web-os-a931cc5c4ad33474ce47f43a0e5baf0a.png";